export class UserProfile {
  
  sid: string;
  sub: string;
  auth_time: number;
  expires_at: number;
  username: string;
  //role(s)
  role: string;
  //test claim(s)
  center_management_none: string;
  member_management_all: string;
  //organization
  organization_short_name: string;
  organization_id: string;
    
}
